import { render, staticRenderFns } from "./FileBreadcrumb.vue?vue&type=template&id=510bf5be&scoped=true"
import script from "./FileBreadcrumb.vue?vue&type=script&lang=js"
export * from "./FileBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510bf5be",
  null
  
)

export default component.exports